import { apiSlice } from "../api/apiSlice";

export const soilDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    soilChartDataFetch: builder.mutation({
      query: (data) => ({
        url: "/apiV2/soil_chart",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useSoilChartDataFetchMutation } = soilDetailsApi;
